// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import { createSelector } from 'reselect';

import { RootState } from '../../rootReducer';
import { Selector } from 'react-redux';
import { ProductCard } from '../../../components/NewCard/types';
import CommonContext from '../../../contexts/CommonContext';
import { KeywordTitle } from '../../actionCreators/search/searchOnlineCoursesKeywordActions';
import { useContext } from 'react';
import { getMultilangs } from '../../../components/common/Multilang';
import { similarWordPoints } from '../../../lib/utility';
import { SearchOnlineCoursesState } from '../../reducers/searchOnlineCoursesReducer';

export const searchOnlineCoursesRaw = (state: RootState): SearchOnlineCoursesState => state.searchOnlineCoursesReducer;

export const makeSearchOnlineCourses = (): Selector<RootState, ProductCard[]> => {
  return createSelector(
    searchOnlineCoursesRaw,
    (searchOnlineCoursesReducer) => searchOnlineCoursesReducer.onlineCoursesListData.list
  );
};

export const makeIsFetching = (): Selector<RootState, boolean> =>
  createSelector(
    searchOnlineCoursesRaw,
    (searchOnlineCoursesReducer) => searchOnlineCoursesReducer.isFetching
  );

export const makeError = (): Selector<RootState, Error | undefined> =>
  createSelector(
    searchOnlineCoursesRaw,
    (searchOnlineCoursesReducer) => searchOnlineCoursesReducer.error
  );

export const makeHasMore = (): Selector<RootState, boolean> =>
  createSelector(
    searchOnlineCoursesRaw,
    (searchOnlineCoursesReducer) =>
      searchOnlineCoursesReducer.onlineCoursesListData.totalPage > searchOnlineCoursesReducer.onlineCoursesListData.page
  );

export const makeSearchKeywordByKey = (key: string): Selector<RootState, KeywordTitle[]> => {
  return createSelector(
    searchOnlineCoursesRaw,
    (searchOnlineCoursesReducer) => searchOnlineCoursesReducer.onlineCoursesKeyword[key]
  );
};

export const makeSearchCommonKeywordByKey = (key: string): Selector<RootState, KeywordTitle[]> => {
  return createSelector(
    searchOnlineCoursesRaw,
    () => {
      const common = useContext(CommonContext);
      const filteredDomains = getMultilangs(common.domains)
        .filter((domain) => similarWordPoints(domain.name, key) > 0.5)
        .map((domain) => ({ name: domain.name, id: -1 }));
      const filteredPlatforms = getMultilangs(common.platforms)
        .filter((platform) => similarWordPoints(platform.name, key) > 0.5)
        .map((platform) => ({ name: platform.name, id: -1 }));

      return [
        ...filteredPlatforms, ...filteredDomains
      ]
    }
  )
}

export const makeIsMoreFetching = (): Selector<RootState, boolean> =>
  createSelector(
    searchOnlineCoursesRaw,
    (searchOnlineCoursesReducer) => searchOnlineCoursesReducer.isFetchingMore
  );
